import React from 'react';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import s from './s.module.less';

// 工具栏 "+ Add" 下拉 + "Settings" 按钮（原型 toolbarActions；populated 与 waiting 态共用）
type Props = {
    isGroup: boolean;
    onConnectEhr: () => void;
    onAddProvider: () => void;
    onOpenSettings: () => void;
};

const ToolbarActions = ({ isGroup, onConnectEhr, onAddProvider, onOpenSettings }: Props) => {
    const items: MenuProps['items'] = [
        { key: 'ehr', icon: <PlusOutlined />, label: 'Connect EHR' },
        // Add provider 是 group practice 概念；solo 只有自己一个 rendering provider
        ...(isGroup ? [{ key: 'provider', icon: <PlusOutlined />, label: 'Add provider' }] : []),
    ];

    const onMenuClick: MenuProps['onClick'] = ({ key }) => {
        if (key === 'ehr') onConnectEhr();
        if (key === 'provider') onAddProvider();
    };

    return (
        <>
            <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']}>
                <Button className={s.toolbarBtn} icon={<PlusOutlined />}>
                    Add
                </Button>
            </Dropdown>
            <Button className={s.toolbarBtn} onClick={onOpenSettings}>
                Settings
            </Button>
        </>
    );
};

export default ToolbarActions;
